import type { InventoryResource } from '@repo/api-gw-sdk';

import { SidePanelPropsTable } from '../../../sidePanelPropsTable';

export const NeptuneSection = ({
  resource,
}: {
  resource: InventoryResource;
}) => {
  const neptuneProps = resource.resourceProperties?.awsNeptune;

  if (!neptuneProps) {
    return null;
  }

  return (
    <SidePanelPropsTable withDividers columnSpace='medium'>
      <tbody>
        <tr>
          <td className='props-col'>Cluster Identifier</td>
          <td className='break-all'>{neptuneProps.dbClusterIdentifier}</td>
        </tr>
        {neptuneProps.engine && (
          <tr>
            <td className='props-col'>Engine</td>
            <td>{neptuneProps.engine}</td>
          </tr>
        )}
        {neptuneProps.engineVersion && (
          <tr>
            <td className='props-col'>Engine Version</td>
            <td>{neptuneProps.engineVersion}</td>
          </tr>
        )}
        {neptuneProps.status && (
          <tr>
            <td className='props-col'>Status</td>
            <td>{neptuneProps.status}</td>
          </tr>
        )}
        {neptuneProps.endpoint && (
          <tr>
            <td className='props-col'>Endpoint</td>
            <td className='break-all'>{neptuneProps.endpoint}</td>
          </tr>
        )}
        {neptuneProps.readerEndpoint && (
          <tr>
            <td className='props-col'>Reader Endpoint</td>
            <td className='break-all'>{neptuneProps.readerEndpoint}</td>
          </tr>
        )}
        {neptuneProps.port !== undefined && neptuneProps.port > 0 && (
          <tr>
            <td className='props-col'>Port</td>
            <td>{neptuneProps.port}</td>
          </tr>
        )}
        {neptuneProps.instanceCount !== undefined &&
          neptuneProps.instanceCount > 0 && (
            <tr>
              <td className='props-col'>Instance Count</td>
              <td>{neptuneProps.instanceCount}</td>
            </tr>
          )}
        {neptuneProps.storageEncrypted !== undefined && (
          <tr>
            <td className='props-col'>Encrypted</td>
            <td>{neptuneProps.storageEncrypted ? 'Yes' : 'No'}</td>
          </tr>
        )}
        {neptuneProps.kmsKeyId && (
          <tr>
            <td className='props-col'>KMS Key ID</td>
            <td className='break-all'>{neptuneProps.kmsKeyId}</td>
          </tr>
        )}
        {neptuneProps.deletionProtection !== undefined && (
          <tr>
            <td className='props-col'>Deletion Protection</td>
            <td>{neptuneProps.deletionProtection ? 'Enabled' : 'Disabled'}</td>
          </tr>
        )}
        {neptuneProps.iamDbAuthenticationEnabled !== undefined && (
          <tr>
            <td className='props-col'>IAM Authentication</td>
            <td>
              {neptuneProps.iamDbAuthenticationEnabled ? 'Enabled' : 'Disabled'}
            </td>
          </tr>
        )}
        {neptuneProps.enabledCloudwatchLogsExports &&
          neptuneProps.enabledCloudwatchLogsExports.length > 0 && (
            <tr>
              <td className='props-col'>CloudWatch Logs</td>
              <td>{neptuneProps.enabledCloudwatchLogsExports.join(', ')}</td>
            </tr>
          )}
      </tbody>
    </SidePanelPropsTable>
  );
};
